import { useMemo } from "react";
import { useResponsive } from "capitalrx-components-2.0/lib/layout";

export const useCheckCurrentScreen = () => {
  const { screen } = useResponsive(
    useMemo(
      () => ({
        screen: { desktop: "desktop", tablet: "tablet", mobile: "mobile" },
      }),
      [],
    ),
  );

  return screen;
};
